// Copyright ©️ 2026 eVolve MEP, LLC

// NOTE: These are the only fonts supported out-of-the-box by jsPDF.
const SUPPORTED_FONT_FAMILIES = ['arial', 'times', 'courier'] as const;
export type SupportedFontFamily = (typeof SUPPORTED_FONT_FAMILIES)[number];
export const isSupportedFontFamily = (fontFamily: string): fontFamily is SupportedFontFamily =>
  SUPPORTED_FONT_FAMILIES.some((supportedFontFamily) => supportedFontFamily === fontFamily);

type FontFamilyOption = {
  value: SupportedFontFamily;
  label: string;
};

export const FONT_FAMILY_OPTIONS: FontFamilyOption[] = [
  { value: 'arial', label: 'Arial' },
  { value: 'times', label: 'Times New Roman' },
  { value: 'courier', label: 'Courier' },
];
